import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { FileDown, Upload } from "lucide-react";
import { API, downloadBlob } from "../../../lib/apiClient";
import { Modal } from "../Shared";

export function ImportModal({ onClose, onSaved }) {
  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const downloadTemplate = () => downloadBlob(`${API}/inventory/import/template`, "inventory_import_template.csv", "Template downloaded");

  const submit = async () => {
    if (!file) { toast.error("Choose a CSV file first"); return; }
    setSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const res = await axios.post(`${API}/inventory/import`, formData, { headers: { "Content-Type": "multipart/form-data" } });
      setResult(res.data);
      toast.success(`${res.data.created} added, ${res.data.updated} updated`);
      onSaved();
    } catch (err) { toast.error(err.response?.data?.detail || "Could not import file"); } finally { setSubmitting(false); }
  };

  return <Modal title="Import inventory from CSV" onClose={onClose}>
    <div className="modal-form">
      <p className="import-hint">Columns: name, category, sku, quantity, unit, min_threshold, unit_cost, batch_number, supplier_or_client. Rows with a SKU that already exists will update that item.</p>
      <button type="button" className="text-button" data-testid="import-download-template-button" onClick={downloadTemplate}><FileDown size={14} /> Download CSV template</button>
      <label>CSV file
        <input type="file" accept=".csv" data-testid="import-file-input" onChange={(e) => setFile(e.target.files[0])} />
      </label>
      {result && <div className="import-result" data-testid="import-result">
        <span className="import-stat created" data-testid="import-result-created">{result.created} added</span>
        <span className="import-stat updated" data-testid="import-result-updated">{result.updated} updated</span>
        {result.errors.length > 0 && <span className="import-stat errors" data-testid="import-result-errors">{result.errors.length} skipped</span>}
        {result.errors.length > 0 && <ul className="import-error-list">{result.errors.slice(0, 8).map((e, i) => <li key={i}>Row {e.row}: {e.reason}</li>)}</ul>}
      </div>}
      <div className="modal-actions">
        <button type="button" className="button ghost" data-testid="import-cancel-button" onClick={onClose}>Close</button>
        <button type="button" className="button primary" data-testid="import-submit-button" onClick={submit} disabled={submitting}><Upload size={16} /> {submitting ? "Importing…" : "Import file"}</button>
      </div>
    </div>
  </Modal>;
}
